var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.001 4H4.582L.5 19.771V20h2.824l.697-3.04h4.423L9.14 20h2.96v-.229L8 4zm-3.249 9.806l1.446-6.217h.068l1.446 6.217h-2.96zM20.83 4v6.126h-4.78V4h-2.67v16h2.67v-6.651h4.78V20h2.67V4h-2.67z"
  })));
}
export default SvgAh;